import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Page from "../../components/layout/Page";
import { Loading, Button, InfoBox } from "../../components/widgets";
import * as registrationActions from "../../redux/actions/registration";
import Permissions from "../../permissions";
import { confirm } from "../../utils/dialogs";
import CustomerForm from "../../components/ordering/CustomerForm";
import { validateAddress, validateEmail } from "../../utils/registration";

const mapStateToProps = state => ({
  user: state.user.account,
  newCustomerErrors: state.registration.newCustomerErrors,
  savingCustomer: state.registration.savingCustomer,
  saveError: state.registration.saveError,
});

const mapDispatchToProps = dispatch => {
  return {
    registrationActions: bindActionCreators(registrationActions, dispatch),
  };
};

class OrderingCustomerRegistrationForm extends Component {
  constructor(props) {
    super(props);

    if (props.customer) {
      this.state = {
        customer: {
          id: props.customer.id,
          nmi: props.customer.nmi,
          addressLine1: props.customer.addressLine1,
          city: props.customer.city,
          state: props.customer.state,
          postcode: props.customer.postcode,
          phone: props.customer.phone,
          email: props.customer.email,
        },
        errors: {},
      };
    } else {
      this.state = {
        customer: {
          id: "",
          nmi: "",
          addressLine1: "",
          city: "",
          state: "",
          postcode: "",
          phone: "",
          email: "",
        },
        errors: {},
      };
    }
  }

  componentDidMount = () => {
    const id = this.props.match.params.id;
    if (id) {
      this.props.registrationActions.fetchCustomerRegistration(id);
    }
  };

  componentWillUnmount = () => {
    this.props.registrationActions.clearActiveCustomer();
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.customer !== nextProps.customer && nextProps.customer) {
      this.setState({
        customer: {
          id: nextProps.customer.id,
          nmi: nextProps.customer.nmi,
          addressLine1: nextProps.customer.addressLine1,
          city: nextProps.customer.city,
          state: nextProps.customer.state,
          postcode: nextProps.customer.postcode,
          email: nextProps.customer.email,
          phone: nextProps.customer.phone,
        },
      });
    }
  };

  handleFieldOnChange = (fieldName, value) => {
    this.setState({
      customer: {
        ...this.state.customer,
        [fieldName]: value,
      },
    });
  };

  validateCustomer = () => {
    let errors = {};
    if (!this.state.customer.name) {
      errors.name = "You must enter the customer's name.";
    }

    if (!this.state.customer.email) {
      errors.email = "You must enter the customer's email address.";
    }

    if (!this.state.customer.phone) {
      errors.phone = "You must enter the customer's phone number.";
    }

    if (this.state.customer.email) {
      if (!validateEmail(this.state.customer.email)) {
        errors.email = "Please enter a valid email address.";
      }
    }

    if (!this.state.customer.addressLine1) {
      errors.addressLine1 = "You must enter the first line of the address.";
    }

    if (this.state.customer.addressLine1) {
      if (!validateAddress(this.state.customer.addressLine1)) {
        errors.addressLine1 = "Please enter a valid address. For example, 1 Example Street.";
      }
    }

    if (!this.state.customer.city) {
      errors.city = "You must enter a city or suburb.";
    }

    if (!this.state.customer.postcode) {
      errors.postcode = "You must enter a postcode.";
    }

    if (this.state.customer.postcode) {
      if (isNaN(this.state.customer.postcode)) {
        errors.postcode = "Please enter a valid postcode.";
      }
    }

    if (!this.state.customer.state) {
      errors.state = "You must select a state.";
    }

    return errors;
  };

  hasErrors = errors => {
    return (
      errors.name ||
      errors.addressLine ||
      errors.city ||
      errors.postcode ||
      errors.state ||
      errors.email
    );
  };

  getNonFieldErrors = () => {
    const errors = this.props.newCustomerErrors;
    if (errors instanceof Array) {
      return errors[0];
    }
  };

  saveCustomer = () => {
    const errors = this.validateCustomer();
    const hasErrors = this.hasErrors(errors);

    if (hasErrors) {
      this.setState({
        errors: errors,
      });
    } else {
      this.setState({
        errors: {},
      });

      if (this.props.id) {
        this.props.registrationActions.saveCustomer(this.state.customer);
      } else {
        this.createCustomer();
      }
    }
  };

  createCustomer = () => {
    confirm("new-customer", "Are you sure you would like to register a new customer?")
      .then(() => {
        this.props.registrationActions.createCustomer(this.state.customer);
        this.setState({
          customer: {
            id: "",
            name: "",
            nmi: "",
            addressLine1: "",
            city: "",
            state: "",
            postcode: "",
            phone: "",
            email: "",
          },
        });
      })
      .catch(() => null);
  };

  render() {
    const id = this.props.match.params.id;

    if (id && !this.props.customer) {
      return <Loading />;
    }

    const customer = this.props.customer;

    return (
      <Page permission={Permissions.fleet.registration.customer.any}>
        <Page.Header title={id ? `Edit Customer ${customer.nmi}` : "Add Customer"}>
          <Page.Header.Actions>
            <Button
              id="registration-save-customer"
              type="primary"
              icon="check"
              onClick={this.saveCustomer}
              loading={this.props.savingCustomer}
            >
              Save
            </Button>
          </Page.Header.Actions>
        </Page.Header>
        <Page.Content>
          {this.getNonFieldErrors() ? (
            <span style={{ color: "#E0004D", fontSize: "0.9em", paddingTop: "1em" }}>
              {this.getNonFieldErrors()}
            </span>
          ) : null}
          {this.props.saveError && (
            <InfoBox type="error" message={`Error saving customer: ${this.props.saveError}.`} />
          )}
          <CustomerForm
            name={this.state.customer.name}
            nmi={this.state.customer.nmi}
            addressLine1={this.state.customer.addressLine1}
            phone={this.state.customer.phone}
            email={this.state.customer.email}
            city={this.state.customer.city}
            state={this.state.customer.state}
            postcode={this.state.customer.postcode}
            handleFieldOnChange={this.handleFieldOnChange}
            errors={this.state.errors}
          />
        </Page.Content>
      </Page>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderingCustomerRegistrationForm);
